
import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import GradientHexagon from '~/components/UIComponents/GradientHexagon.vue';
import SimpleInfoCard from '~/components/UIComponents/SimpleInfoCard.vue';
import { ICurrentPage } from '~/store/types';

@Component({
  components: { GradientHexagon, SimpleInfoCard },
})
export default class GetGalaPage extends Vue {
  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  get ways() {
    return [
      {
        number: 1,
        title: this.$t('pages.getGala.buyFromExchange.heading'),
        text: this.$t('pages.getGala.buyFromExchange.text'),
        imgSrc: 'https://static.gala.games/images/get-gala/icon_exchange.png',
        exchanges: [
          {
            title: 'Binance',
            logo: require('@/assets/logos/logo_binance.png'),
            btnText: this.$t('pages.getGala.buyFromExchange.galaBnb'),
            link: 'https://www.binance.com/en/price/gala?ref=GALA',
          },
          {
            title: 'Coinbase',
            logo: require('@/assets/logos/logo_coinbase.png'),
            btnText: this.$t('pages.getGala.buyFromExchange.galaUsd'),
            link: 'https://www.coinbase.com/price/gala',
          },
          {
            title: 'Crypto.com',
            logo: require('@/assets/logos/logo_crypto_com.png'),
            btnText: this.$t('pages.getGala.buyFromExchange.galaUsdt'),
            link: 'https://crypto.com/price/gala',
          },
          {
            title: 'Okex',
            logo: require('@/assets/logos/logo_okex.png'),
            btnText: this.$t('pages.getGala.buyFromExchange.galaUsdt'),
            link: 'https://www.okex.com/markets/spot-info/gala-usdt',
          },
          {
            title: 'Kucoin',
            logo: require('@/assets/logos/logo_kucoin.png'),
            btnText: this.$t('pages.getGala.buyFromExchange.galaxUsdt'),
            link: 'https://trade.kucoin.com/trade/GALAX-USDT',
          },
          {
            title: 'Gate.io',
            logo: require('@/assets/logos/logo_gate_io.png'),
            btnText: this.$t('pages.getGala.buyFromExchange.galaUsdt'),
            link: 'https://www.gate.io/en/trade/GALA_USDT',
          },
          {
            title: this.$t('pages.getGala.buyFromExchange.uniswap'),
            logo: require('@/assets/logos/logo_uniswap.png'),
            btnText: this.$t('pages.getGala.buyFromExchange.galaEth'),
            link: 'https://info.uniswap.org/#/pools/0xf8a95b2409c27678a6d18d950c5d913d5c38ab03',
          },
          {
            title: this.$t('pages.getGala.buyFromExchange.bithumb'),
            logo: require('@/assets/logos/logo_bithumb.png'),
            btnText: this.$t('pages.getGala.buyFromExchange.galaKrw'),
            link: 'https://www.bithumb.com/trade/order/GALA_KRW',
          },
          {
            title: this.$t('pages.getGala.buyFromExchange.ftx'),
            logo: require('@/assets/logos/logo_FTX_dark.png'),
            btnText: this.$t('pages.getGala.buyFromExchange.galaFtx'),
            link: 'https://ftx.com/en',
          },
        ],
      },
    ];
  }

  get infoCards() {
    return [
      {
        uniqueId: 'get-gala-smart-contract',
        title: this.$t('pages.getGala.smartContract.heading'),
        imgSrc: require('@/assets/icons/icon_node_ecosystem.png'),
        content: this.$t('pages.getGala.smartContract.text'),
        btnText: this.$t('pages.getGala.smartContract.cta'),
        link: 'https://etherscan.io/token/0x15D4c048F83bd7e37d49eA4C83a07267Ec4203dA',
      },
      {
        uniqueId: 'node-community',
        title: this.$t('pages.getGala.decentralization.heading'),

        imgSrc: require('@/assets/icons/icon_node_community.png'),
        content: this.$t('pages.getGala.decentralization.text'),
        btnText: this.$t('common.cta.readMore'),
        link: 'https://gogalagames.medium.com/the-gala-games-node-ecosystem-9760d8156af7',
      },
    ];
  }
  galaCube = require('@/assets/icons/icon_gala_cube.png');

  async created() {
    this.updateCurrentPage({
      title: 'Get GALA',
      backIcon: 'arrow_back_ios',
      backRoute: `/`,
    });
  }

  goTo(route: string) {
    this.$router.push(route);
  }
}
